var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 100C78.1142 100 100.5 77.6142 100.5 50C100.5 22.3858 78.1142 0 50.5 0C22.8858 0 0.5 22.3858 0.5 50C0.5 77.6142 22.8858 100 50.5 100Z",
    fill: "#32BA7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.724 72.5552L63.4338 98.265C84.7272 92.5867 100.5 73.1861 100.5 50V48.5804L80.3107 29.9684L37.724 72.5552Z",
    fill: "#0AA06E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7618 61.1988C53.97 63.407 53.97 67.1924 51.7618 69.4007L47.1877 73.9748C44.9795 76.183 41.194 76.183 38.9858 73.9748L18.9542 53.7855C16.746 51.5773 16.746 47.7918 18.9542 45.5836L23.5284 41.0095C25.7366 38.8013 29.5221 38.8013 31.7303 41.0095L51.7618 61.1988Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2697 26.3407C71.4779 24.1325 75.2634 24.1325 77.4716 26.3407L82.0457 30.9149C84.2539 33.1231 84.2539 36.9085 82.0457 39.1167L47.3454 73.6593C45.1372 75.8675 41.3517 75.8675 39.1435 73.6593L34.5694 69.0852C32.3612 66.877 32.3612 63.0915 34.5694 60.8833L69.2697 26.3407Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0cf3b755.svg";
export { ForwardRef as ReactComponent };